{
  "showMore": "Vis mer",
  "hiddenTabs": "Skjulte faner"
}
